import type { ComponentType } from 'react';

import { BuyItAgain } from '../components/buy-it-again';
import CampaignBannerSm from '../components/CampaignBannerSm';
import CampaignCardsUp from '../components/CampaignCardsUp';
import CampaignHero from '../components/CampaignHero';
import CardUp from '../components/card-up';
import Faq from '../components/Faq';
import FeatureBanner from '../components/FeatureBanner';
import LivesSaved from '../components/LivesSaved';
import { MainMenu } from '../components/MainMenu';
import ProductCarousel from '../components/ProductCarousel';
import SecondaryNavigation from '../components/SecondaryNavigation/SecondaryNavigation';
import { SeoBlock } from '../components/SeoBlock';
import SiteWidePromoBanner from '../components/SiteWidePromoBanner';
import SiteWidePromoBannerCarousel from '../components/SiteWidePromoBannerCarousel';
import StorytellingCardUp from '../components/StorytellingCardUp';
import Tile6Up from '../components/Tile6Up';
import Tiles4 from '../components/Tiles4';
import type { PropsType } from '../types';

export const componentMapping: Record<string, ComponentType<PropsType>> = {
    mainMenu: MainMenu as ComponentType<PropsType>,
    livesSaved: LivesSaved as ComponentType<PropsType>,
    siteWidePromoBanner: SiteWidePromoBanner as ComponentType<PropsType>,
    siteWidePromoBannerCarousel: SiteWidePromoBannerCarousel as ComponentType<PropsType>,
    seoBlock: SeoBlock as ComponentType<PropsType>,
    faq: Faq as ComponentType<PropsType>,
    featureBanner: FeatureBanner as ComponentType<PropsType>,
    productCarousel: ProductCarousel as unknown as ComponentType<PropsType>,
    tile6Up: Tile6Up as ComponentType<PropsType>,
    cardUp: CardUp as ComponentType<PropsType>,
    campaignCardsUp: CampaignCardsUp as ComponentType<PropsType>,
    secondaryNavigation: SecondaryNavigation as ComponentType<PropsType>,
    campaignBannerSm: CampaignBannerSm as ComponentType<PropsType>,
    campaignHero: CampaignHero as ComponentType<PropsType>,
    storytellingCardUp: StorytellingCardUp as ComponentType<PropsType>,
    tiles4: Tiles4 as ComponentType<PropsType>,
    buyAgainCarousel: BuyItAgain as ComponentType<PropsType>,
};
